//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpButton from '../../button/Button.vue';
import DpInput from '../../input/Input.vue';
import DpControlGroup from '../../layout/ControlGroup.vue';

export default {
  name: 'DpWizardHeader',
  components: {
    DpButton,
    DpInput,
    DpControlGroup,
  },
  props: {
    name: { type: String, default: null },
    sections: { type: Array, default: () => [] },
    activeSection: { type: String, default: null },
    saveDisabled: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      internalName: null,
    };
  },
  watch: {
    name: {
      immediate: true,
      handler(name) {
        this.internalName = name;
      },
    },
  },
  methods: {
    changeSection(section) {
      if (section.disabled) return;
      this.$emit('change-section', section.name);
    },
  },
};
